/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Modal, Button, Popover, OverlayTrigger, Row, Col, Label} from 'react-bootstrap';
import DraggableModalDialog from './../DraggableModal';
import { connect } from 'react-redux';


var PortNumberDialog = React.createClass({
    getInitialState() {
        return {startPort: 1,
                portError: null}
    },

    ptChange(e) {
        let startPort = e.target.value;
        this.setState(Object.assign({}, this.state, {
            startPort: startPort,
            portError: portValidator(startPort)
        }));
    },

    ptStatus() {
        if (this.state.portError) {
            return "has-error";
        } else {
            return "has-success";
        }
    },

    applyHandler() {
        if (this.state.portError) {
            return;
        }
        let newNet = assignPorts(parseInt(this.state.startPort), this.props.net);
        this.props.updatePortNumbers(newNet);
    },

    removeHandler() {
        let newNet = removePorts(this.props.net);
        this.props.updatePortNumbers(newNet);
    },

    helpPopover(){
        let portErrorP;
        if (this.state.portError) {
            portErrorP = <p> <Label bsStyle="danger">Error: </Label>{this.state.portError}</p>;
        }
        return (<Popover  id="PortNumberHelpPopover" title="Port Numbering Help" bsSize="lg">
            <p>This function will assign node port numbers to each end of a link in the network.
                It may <strong>change</strong> any existing port assignments.</p>
            <p>Such functionality is needed if forwarding or switching tables will be computed for the
                network nodes. You can specify the starting (lowest) port number used on the switches.</p>
            {portErrorP}
        </Popover>)
    },

    render(){

        return(
        <Modal show={this.props.open} onHide={this.props.close} dialogClassName="port-num-modal"
               dialogComponentClass={DraggableModalDialog}
           enforceFocus={false} backdrop={false} >
            <Modal.Header closeButton>
                <Modal.Title>Port Numbering</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{paddingBottom: 0}}>
                               <form className="form-horizontal">
                            <Row>
                                <div className={this.ptStatus()}>
                                    <Col xs={6} xsOffset={1}>
                                        <label className="control-label">Starting Port Number</label>
                                    </Col>
                                    <Col xs={3}>
                                        <input type="text" value={this.state.startPort}
                                               onChange={this.ptChange}
                                               className="form-control"/>
                                    </Col>
                                </div>
                            </Row>
                    </form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle="primary"
                            onClick={this.applyHandler} disabled={Boolean(this.state.portError)}>Add </Button>
                <Button bsStyle="warning" onClick={this.removeHandler}>Remove</Button>
                <Button onClick={this.props.close} >Close</Button>
                <OverlayTrigger trigger="click" placement="bottom" overlay={this.helpPopover()}>
                    <Button bsStyle={'info'}>Help</Button>
                </OverlayTrigger>
            </Modal.Footer>
            </Modal> 
    )}
});

function portValidator(pString) {
    let value = parseInt(pString);
    if (isNaN(value)) {
        return "Starting port number: must be a valid number."
    }
    if (value < 0) {
        return "Starting port number: must be non-negative."
    }
    return null;
}

function assignPorts(startPort, net) {
    let links = net.links.map(l => Object.assign({}, l)); // Make a copy of the link array
    let nodes = net.nodes;
    let nodePortMap = new Map();
    // Initialize the node port counters
    for (let node of nodes) {
        nodePortMap.set(node.id, startPort);
    }
    for (let link of links) {
        let srcPort = nodePortMap.get(link.source);
        nodePortMap.set(link.source, srcPort + 1);
        let trgPort = nodePortMap.get(link.target);
        nodePortMap.set(link.target, trgPort + 1);
        link.ports = {};
        link.ports[link.source] = srcPort;
        link.ports[link.target] = trgPort;
    }
    return Object.assign({}, net, {links: links});
}

function removePorts(net) {
    let links = net.links.map(l => Object.assign({}, l)); // Make a copy of the link array
    let nodes = net.nodes;
    for (let link of links) {
        delete link.ports;
    }
    return Object.assign({}, net, {links: links});
}

const mapStateToProps = (state) => {
    return {
        open: state.uiState.showPortNumberModal,
        net: state.net
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch({type: 'CLOSE_PORT_NUMBER_DIALOG'});
        },
        updatePortNumbers: (net) => {
            dispatch({type: 'UPDATE_PORT_NUMBERS', net: net});
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PortNumberDialog)




// WEBPACK FOOTER //
// ./src/netManip/PortNumberDialog.js